import createUrlBuilder from 'utilities/url.builder.utils';
import { getRequest } from 'utilities/service.utils';
import AppService from './app.service.context';
import { DashboardStatsRequestParams } from 'types';

export const getDashboardEnquirerStats = async (
  params: DashboardStatsRequestParams
) => {
  const urlBuilder = createUrlBuilder(`/stats/dashboard/enquirer`).toString();

  return await getRequest(AppService, urlBuilder, params);
};

export const getDashboardAssetOnwerStats = async (
  params: DashboardStatsRequestParams
) => {
  const urlBuilder = createUrlBuilder(`/stats/dashboard/assetowner`).toString();

  return await getRequest(AppService, urlBuilder, params);
};

export const getDashboardDBYDAdminStats = async (
  params: DashboardStatsRequestParams
) => {
  const urlBuilder = createUrlBuilder(`/stats/dashboard/dbydadmin`).toString();

  return await getRequest(AppService, urlBuilder, params);
};
